<template>
  <div class="home" style="witdh: 100%">
    <div id="video">
      <video src="./a.mp4" autoplay muted loop class="video"></video>
      <section class="contenido">
        <h1 id="hache1">INNOVATING DRONES</h1>

        <h2 id="hache1" @click="jumpScroll" style="font-size: 15px">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            fill="currentColor"
            class="bi bi-chevron-double-down"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
            <path
              fill-rule="evenodd"
              d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            /></svg
          ><br />
        </h2>
      </section>
    </div>

    <div class="fotos">
      <img src="./1.png" alt="" style="width: 300px" height="100px" />
      <img src="./2.jpg" alt="" width="300px" height="140px" />
      <img src="./2.png" alt="" width="350px" height="120px" />
    </div>

    <productos /> <HelloWorld />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import productos from "@/components/productos.vue";

export default {
  name: "Home",
  components: {
    HelloWorld,
    productos,
  },

  methods: {
    jumpScroll() {
      // window.scroll(0, 450);
      //  behavior: 'smooth'
      window.scroll({
        top: 480,
        left: 100,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.fotos {
  display: flex;
  flex-wrap: wrap;
  background-color: white;
  padding: 30px;
  justify-content: center;
}
#video {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1vh;
  /* background-image: linear-gradient(to right, rgba(13, 25, 133, 0.39), #170627bb); */
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  height: 70vh;
   font-family: 'Big Shoulders Display', cursive;
}

video {
  object-fit: cover;
  z-index: -1;
}

#img {
  width: 100%;
}

#hache1 {
  background-color: rgba(68, 68, 68, 0.292);
  padding: 15px;
  border-radius: 5px;
 font-family: 'Big Shoulders Display', cursive;
  font-weight: 700;
  line-height: 26.4px;
}

.contenido {
  position: absolute;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: 80%;

  padding: 20px;
  text-align: center;
  color: rgba(228, 228, 228, 0.792);
}
</style>
